// ✅ Semua import HARUS di sini
import 'dialog-polyfill/dialog-polyfill.css';

// ✅ Kalau kamu juga pakai JS (bukan JSX), ini tetap bisa ditaruh di file `.js`

// Harus setelah import, baru logika
if (typeof window.HTMLDialogElement === 'undefined') {
  window.HTMLDialogElement = function () {};
}

// Polyfill / Shim
(() => {
  const originalCreateElement = document.createElement;

  document.createElement = function (tagName, options) {
    const element = originalCreateElement.call(document, tagName, options);

    if (tagName.toLowerCase() === 'dialog') {
      console.log('[Dialog Shim] <dialog> created');

      // Tambahkan method jika belum ada
      if (typeof element.showModal !== 'function') {
        element.showModal = function () {
          this.open = true;
          this.style.display = 'block';
          console.log('[Dialog Shim] showModal()');
        };
      }

      if (typeof element.close !== 'function') {
        element.close = function () {
          this.open = false;
          this.dispatchEvent(new Event('close'));
          this.style.display = 'none';
          console.log('[Dialog Shim] close()');
        };
      }
    }

    return element;
  };
})();

// Suppress error tertentu
if (process.env.REACT_APP_NODE_ENV === 'production') {
  console.log = function () {};
  console.info = function () {};
} else {
  const originalConsoleError = console.error;

  console.error = function (message, ...args) {
    const suppressedErrors = [
      'findDOMNode is deprecated',
      'HTMLDialogElement',
      'this.ej.close is not a function',
      'this.ej is not an object',
			'Google Analytics gtag is not initialized',
			'Google Tag Manager gtm is not initialized',
      'Invalid DOM property',
      'google.maps.Map is not a constructor',
      'undefined is not a constructor',
    ];

    const shouldSuppress = suppressedErrors.some(
      (err) => typeof message === 'string' && message.includes(err)
    );

    if (!shouldSuppress) {
      originalConsoleError.apply(console, [message, ...args]);
    }
  };
}